// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__hFeZK","rotation":"SmallLoader_rotation__5rBPo"};